import { useSelector } from "react-redux"
import type { UserRole } from "../types/user.types"
import { selectCurrentUser } from "../app/authSlice"

const useAuth = () => {
  const user = useSelector(selectCurrentUser)

  if (user) return user

  return {
    emailVerified: false,
    uid: "",
    email: "",
    role: "" as UserRole
  }
}

export default useAuth